import { Tile, TileState, Empty, Chip } from "./Tile";
import { useDash } from "../../lib/dash";

const Swatch = ({ hex }) => (
  <span className="inline-block h-3 w-3 shrink-0 rounded-[4px] border border-border" style={{ background: hex }} />
);

const Spool = ({ s, testid }) => (
  <span data-testid={testid} className="inline-flex min-w-0 items-center gap-1.5 whitespace-nowrap">
    <Swatch hex={s.hex} />
    <span className="truncate">{s.name}</span>
    <span className="shrink-0 font-mono2 text-[11px] text-muted-foreground">dE {s.de} · hue {s.hue_off}°</span>
  </span>
);

const GapRow = ({ g, i }) => (
  <tr data-testid={`catalog-gap-row-${i}`} className="border-b border-border/60 align-top last:border-0">
    <td className="py-1.5 pr-3">
      <span className="inline-flex items-center gap-1.5 font-mono2 text-[12px]"><Swatch hex={g.render_hex} />{g.render_hex}</span>
      {g.over && <span className="ml-1.5"><Chip tone="amber" testid={`catalog-gap-over-${i}`}>over dE 15</Chip></span>}
    </td>
    <td className="py-1.5 pr-3 text-muted-foreground">{g.region.replace("_", " ")}</td>
    <td className="py-1.5 pr-3"><Spool s={g.closest} testid={`catalog-gap-closest-${i}`} /></td>
    <td className="py-1.5 pr-3"><Spool s={g.pick} testid={`catalog-gap-pick-${i}`} /></td>
    <td data-testid={`catalog-gap-ducks-${i}`} className="py-1.5">
      <span className="font-semibold tabular-nums">{g.n_ducks}</span>{" "}
      <span className="text-muted-foreground">{g.ducks.map((d) => d.name || d.id.slice(0, 8)).join(", ")}</span>
    </td>
  </tr>
);

// Step 3b: render colors no spool we stock qualifies for (they pass on the closest spool or the hue-keeping pick).
export const CatalogGapsTile = ({ index }) => {
  const s = useDash("/dash/catalog-gaps");
  const gaps = s.data?.gaps || [];
  return (
    <Tile id="catalog-gaps" index={index} tone={gaps.some((g) => g.over) ? "amber" : null} kicker="Filament to buy" title="Catalog gaps">
      <TileState state={s}>
        {gaps.length === 0 ? (
          <Empty testid="catalog-gaps-empty">No catalog gaps. One is listed when a duck is built or repainted with a render color no spool we stock matches.</Empty>
        ) : (
          <div className="min-h-0 flex-1 overflow-auto pr-1">
            <table data-testid="catalog-gaps-table" className="w-full min-w-[760px] text-left text-[12.5px]">
              <thead className="text-[11px] uppercase tracking-wider text-muted-foreground">
                <tr><th className="pb-1 pr-3 font-semibold">Render color</th><th className="pb-1 pr-3 font-semibold">Region</th>
                  <th className="pb-1 pr-3 font-semibold">Closest spool</th><th className="pb-1 pr-3 font-semibold">Hue-keeping pick</th>
                  <th className="pb-1 font-semibold">Ducks</th></tr>
              </thead>
              <tbody>{gaps.map((g, i) => <GapRow key={`${g.region}-${g.render_hex}`} g={g} i={i} />)}</tbody>
            </table>
          </div>
        )}
      </TileState>
    </Tile>
  );
};
